<div class="row">
  <div class="col-6">
    <div class="form-container" fxLayout="column">
      <usimweb-select
        [fullWidth]="true"
        [default]="meshing.appType"
        [options]="appTypes"
        [placeholder]="'Simulation app typ'"
        (selectionChange)="selectedAppType($event)"
      ></usimweb-select>

      <div *ngIf="isImport" fxLayout="row">
        <div class="block">
          <div class="bottom-spacer">
            <label for="file-upload" class="import-btn">Import</label>
            <input id="file-upload" type="file" (change)="uploadFile($event)" accept=".stl" multiple />
          </div>
        </div>

        <div *ngIf="meshing.appType !== 'porousBox'" class="block-container">
          <div class="form-container">
            <usimweb-input [(value)]="meshing.modelKey" [placeholder]="'File name'" [readonly]="true"></usimweb-input>
          </div>
        </div>
      </div>

      <usimweb-form-input
        placeholder="Geometry name"
        (selectionChange)="meshing.title = $event"
        [required]="true"
      ></usimweb-form-input>

      <div>
        <div *ngFor="let mesh of meshing | keyvalue">
          <div *ngIf="isArray(mesh.value)">
            <div *ngFor="let zones of $any(mesh.value)">
              <div *ngFor="let zone of zones | keyvalue">
                <div *ngIf="isInputValue(zone)">
                  <usimweb-form-input
                    [placeholder]="getName(zone.value)"
                    [value]="getValue(zone.value)"
                    (selectionChange)="changedValue($event, zone.key)"
                    [required]="true"
                  ></usimweb-form-input>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!isArray(mesh.value)">
            <div *ngIf="isInputValue(mesh)">
              <usimweb-form-input
                [placeholder]="getName(mesh.value)"
                [value]="getValue(mesh.value)"
                (selectionChange)="changedValue($event, mesh.key)"
                [required]="true"
              ></usimweb-form-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-6">
    <div *ngIf="isLoading">
      <div class="padding">
        <usimweb-progress-bar [mode]="'indeterminate'"></usimweb-progress-bar>
      </div>
    </div>

    <div *ngIf="isImport" class="render-div" id="renderDiv"></div>

    <div>
      <img [attr.src]="preview" attr.width="{{ scale }}%" attr.height="{{ scale }}%" alt="" />
    </div>
  </div>
</div>
